import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SearchWidget from 'components/SearchWidget'
import { useProfile } from 'profile'
import { HelpContextProvider, WelcomeToPageButton } from 'lib-core'

const HomePostsExtraNav = () => {
  const dispatch = useDispatch()
  const { place } = useSelector(selectHomePostsExtraNav)
  const {profile} = useProfile()
  return (
    <>
    <SearchWidget
      onSearch={s => {
        dispatch({
          type: place,
          payload: {
            search: s
          }
        })
      }}
      onCancelSearch={() => {     
        dispatch({
          type: place,
          payload: {}
        })
      }}
    />
    <HelpContextProvider page="main" profile={profile}>
      <WelcomeToPageButton />
    </HelpContextProvider>
    </>
  )
}

const selectHomePostsExtraNav = ({ location: { type } }) => ({ place: type })


export default HomePostsExtraNav
